export enum UsePriority {
    NONE = 0,
    ORDER = 1,
    SAMPLE = 2
}
